import ScreeningQuestions from './ScreeningQuestions';
export default ScreeningQuestions;